import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
declare var $: any;


@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.scss']
})
export class EmpresasComponent implements OnInit {

  public nuevaEmpresaForm: FormGroup;
  public editEmpresaForm: FormGroup;
  public editEmpresaUsuarioForm: FormGroup;
  public editUsuarioForm: FormGroup;
  
  public isAuthLoading = false;


  cargando: boolean =false;
  empresas: any = [];
  // usuarios_empresa: any = [];
  pagesNumber: any;
  offset= 3;
  buscar: any;
  page: any;

  constructor( public router: Router,private toastr: ToastrService, private appService: AppService, private http: HttpClient) { }

  ngOnInit(): void {
    this.getListado();

    this.nuevaEmpresaForm = new FormGroup({
      nombre: new FormControl(null, Validators.required),
      nit: new FormControl(null, Validators.required),
      direccion: new FormControl(null, Validators.required),
      telefono: new FormControl(null, Validators.required),
      encargado: new FormControl(null, Validators.required),
      sigla: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required)
    });
    
    this.editEmpresaForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      nombre: new FormControl(null, Validators.required),
      nit: new FormControl(null, Validators.required),
      direccion: new FormControl(null, Validators.required),
      telefono: new FormControl(null, Validators.required),
      encargado: new FormControl(null, Validators.required),
      sigla: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      cant_usuarios: new FormControl(null, Validators.required),      
      usuarios_empresa: new FormControl(null, Validators.nullValidator),
    }); 
    
    this.editEmpresaUsuarioForm = new FormGroup({
      empresa_id: new FormControl(null, Validators.required),
      nombre: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      perfil_id: new FormControl(null, Validators.required),
    });  
    
    this.editUsuarioForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      empresa_id: new FormControl(null, Validators.required),
      nombre: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      telefono: new FormControl(null, Validators.nullValidator),
      perfil_id: new FormControl(null, Validators.required),
    });      
  }
  

  async newEmpresa() {     
    if (this.nuevaEmpresaForm.valid) {
        this.isAuthLoading = true; 
          let params = {
              nuevo:true,
              nombre: this.nuevaEmpresaForm.value.nombre,
              nit: this.nuevaEmpresaForm.value.nit,
              direccion: this.nuevaEmpresaForm.value.direccion,
              telefono: this.nuevaEmpresaForm.value.telefono,
              encargado: this.nuevaEmpresaForm.value.encargado,
              sigla: this.nuevaEmpresaForm.value.sigla,
              email: this.nuevaEmpresaForm.value.email,            
            };
            // console.log(params);
            this.appService.postEmpresa(params)
          .subscribe( (data) => {
              if (data["logger"] == true){
                  // console.log(data);
                  // this.router.navigate(['/']);
                  this.nuevaEmpresaForm.reset()
                  $('#nuevaEmpresa').modal('hide');
                  this.getListado();
              }else{
                  this.toastr.error(data["msg"]);
              }
          }); 
        this.isAuthLoading = false;
    } else {
        this.toastr.error('El formulario no es válido!');
    }
  }

  editEmpresaModal(item){    
    this.editEmpresaForm.get('id').setValue(item.id);
    this.editEmpresaForm.get('nombre').setValue(item.nombre);
    this.editEmpresaForm.get('nit').setValue(item.nit);
    this.editEmpresaForm.get('direccion').setValue(item.direccion);
    this.editEmpresaForm.get('telefono').setValue(item.telefono);
    this.editEmpresaForm.get('encargado').setValue(item.encargado);
    this.editEmpresaForm.get('sigla').setValue(item.sigla);
    this.editEmpresaForm.get('email').setValue(item.email);    
    this.editEmpresaForm.get('cant_usuarios').setValue(item.cant_usuarios);        
    this.editEmpresaForm.get('usuarios_empresa').setValue(item.usuarios_empresa);    
    $('#editEmpresa').modal('show');
  }

  editEmpresaUsuarioModal(item){
    console.log(item);    
    this.editUsuarioForm.get('id').setValue(item.id);
    this.editUsuarioForm.get('empresa_id').setValue(item.empresa_id);
    this.editUsuarioForm.get('nombre').setValue(item.nombre);
    this.editUsuarioForm.get('email').setValue(item.email);
    this.editUsuarioForm.get('telefono').setValue(item.telefono);
    this.editUsuarioForm.get('password').setValue(item.password);
    this.editUsuarioForm.get('perfil_id').setValue(item.perfil_id);
    $('#editEmpresaUsuario').modal('show');
  }

  async editEmpresa() {     
    if (this.editEmpresaForm.valid) {
        this.isAuthLoading = true; 
          let params = {
              editar:true,
              id: this.editEmpresaForm.value.id,
              nombre: this.editEmpresaForm.value.nombre,
              nit: this.editEmpresaForm.value.nit,
              direccion: this.editEmpresaForm.value.direccion,
              telefono: this.editEmpresaForm.value.telefono,
              encargado: this.editEmpresaForm.value.encargado,
              sigla: this.editEmpresaForm.value.sigla,
              cant_usuarios: this.editEmpresaForm.value.cant_usuarios,
              email: this.editEmpresaForm.value.email,
              estado:1,            
            };
            console.log(params);
            this.appService.postEmpresa(params)
          .subscribe( (data) => {
              if (data["logger"] == true){
                  // console.log(data);
                  // this.router.navigate(['/']);
                  this.toastr.success(data["msg"]);
                  this.editEmpresaForm.reset()
                  $('#editEmpresa').modal('hide');
                  this.getListado();
              }else{
                  this.toastr.error(data["msg"]);
              }
          }); 
        this.isAuthLoading = false;
    } else {
        this.toastr.error('El formulario no es válido!');
    }
  }  

  async editEmpresaUsuario(empresaId) {     
    this.editEmpresaUsuarioForm.get('empresa_id').setValue(empresaId);    
    
    if (this.editEmpresaUsuarioForm.valid) {
        this.isAuthLoading = true; 
          let params = {
              nuevo:true,
              empresa_id: this.editEmpresaUsuarioForm.value.empresa_id,
              nombre: this.editEmpresaUsuarioForm.value.nombre,
              email: this.editEmpresaUsuarioForm.value.email,
              password: this.editEmpresaUsuarioForm.value.password,
              perfil_id: this.editEmpresaUsuarioForm.value.perfil_id,
              estado:1,            
            };
            // console.log(params);
            this.appService.postUsuario(params)
          .subscribe( (data) => {
              if (data["logger"] == true){
                  // console.log(data);
                  // this.router.navigate(['/']);
                  this.editEmpresaForm.value.usuarios_empresa.push(data["obj"]);

                  this.toastr.success(data["msg"]);
                  this.editEmpresaUsuarioForm.reset()
                  $('#collapseAgregarUsuario').collapse('hide');
                  this.getListado();
              }else{
                  this.toastr.error(data["msg"]);
              }
          }); 
        this.isAuthLoading = false;
    } else {
        this.toastr.error('El formulario no es válido!');
    }
  } 

  async editUsuario(id) {     
    this.editUsuarioForm.get('id').setValue(id); 
    console.log(this.editUsuarioForm);
       
    
    if (this.editUsuarioForm.valid) {
        this.isAuthLoading = true; 
          let params = {
              editar:true,
              id: this.editUsuarioForm.value.id,
              empresa_id: this.editUsuarioForm.value.empresa_id,
              nombre: this.editUsuarioForm.value.nombre,
              email: this.editUsuarioForm.value.email,
              password: this.editUsuarioForm.value.password,
              telefono: this.editUsuarioForm.value.telefono,
              perfil_id: this.editUsuarioForm.value.perfil_id,
              estado:1,            
            };
            // console.log(params);
            this.appService.postUsuario(params)
          .subscribe( (data) => {
              if (data["logger"] == true){
                  this.toastr.success(data["msg"]);
                  this.editUsuarioForm.reset()
                  $('#editEmpresaUsuario').modal('hide');
                  $('#editEmpresa').modal('hide');
                  this.getListado();
              }else{
                  this.toastr.error(data["msg"]);
              }
          }); 
        this.isAuthLoading = false;
    } else {
        this.toastr.error('El formulario no es válido!');
    }
  }   

  getListado(page = null){
    this.cargando = true;
    if(!page){
      this.appService.getEmpresas(1).subscribe( (data) => {
        this.empresas = data['empresas'];        
        this.cargando = false;
        this.ForpagesNumber()
      });
    }else{
      var url = this.appService.getEmpresas(page).subscribe( (data) => {
        this.empresas = data['empresas'];
        this.cargando = false;
        this.ForpagesNumber()

      });
    }     
  }

  ForpagesNumber() {
    let from = this.empresas.current - this.offset;
    if(from < 1){
      from = 1;
    }

    let to = from + (this.offset * 2); 
    if(to >= this.empresas.total_page){
      to = this.empresas.total_page;
    }

    let pagesArray = [];
    while(from <= to){
      pagesArray.push(from);
      from++;
    }
    this.pagesNumber = pagesArray;
  }

  changePage(page) {
    this.page = page; //para el filtro
    this.empresas.current = page;
    // this.filtro();
        // this.listadoComercios(page);        
  }  

}
